var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "upload-demo",
      attrs: {
        multiple: "",
        format: _vm.formatArray,
        action: _vm.uploadFileUrl,
        "show-file-list": false,
        "on-success": _vm.uploadSuccess,
        "on-error": _vm.uploadError,
        "before-upload": _vm.beforeUpload,
        accept: _vm.accept,
        "on-format-error": _vm.handleFormatError,
      },
    },
    [
      _c("el-button", { attrs: { type: "danger" } }, [
        _c("i", { staticClass: "iconfont eicon-szkc-shangchuan" }),
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }